import { z } from 'zod';
export const createBookingSpecificitySchema = z.object({
    freeText: z.string().optional(),
    options: z.array(z.string()).min(1),
});
export const markMultipleAsReadSchema = z.object({
    alertIds: z.array(z.string()).min(1, 'Au moins un identifiant requis.'),
});
